import type { GroupType, Option } from "./types";

export function isGroup(item: Option | GroupType): item is GroupType {
  return "options" in item;
}

export function isGroupArray(items: Option[] | GroupType[]): items is GroupType[] {
  return items.length > 0 && isGroup(items[0]);
}

export function isOptionArray(items: Option[] | GroupType[]): items is Option[] {
  return items.length === 0 || !isGroup(items[0]);
}

export function flattenItems(items: Option[] | GroupType[]): Option[] {
  if (!items.length) return [];
  if (isGroupArray(items)) {
    return items.flatMap((group) => group.options);
  }
  return items;
}
